/**
 * @module productDetailPageImageGallery
 */
;(function productDetailPageImageGallery() {
    function productDetailPageImageGallery($dom) {
        /**
         * // local object availability
         * @private
         */
        var _this = this

        /**
         * @method thumbnailsInteraction
         * @returns {undefined}
         */
        this.thumbnailsInteraction = function () {
            var items = $dom.find('[data-product-images="thumbnails"]').children()
            var previewContainer = $dom.find('[data-product-images="preview"]')

            items.on('mouseenter click', function () {
                var hoverItem = $(this)

                if (
                    !(hoverItem.find('[data-element="product-list_product-image"]').data('product-image') === undefined)
                ) {
                    // fix change preview image Bug on slow connection
                    $(previewContainer).css('min-height', $(previewContainer).height() + 'px')

                    items.removeClass('active')
                    hoverItem.addClass('active')
                    previewContainer.empty().append(hoverItem.children().clone())

                    // build preview image src
                    var previewImageSrc = previewContainer
                            .find('[data-element="product-list_product-image"]')
                            .data('product-image'),
                        previewImageWidth = previewContainer
                            .find('[data-element-image="product-list_product-image"]')
                            .data('product-image-width'),
                        previewImageHeight = previewContainer
                            .find('[data-element="product-list_product-image"]')
                            .data('product-image-height')

                    previewContainer
                        .find('img')
                        .attr('src', previewImageSrc)
                        .attr('width', previewImageWidth)
                        .attr('width', previewImageHeight)
                }
            })
            items.first().addClass('active')
        }

        /**
         * @class ShowMoreThumbnails
         * @returns {undefined}
         */
        this.showMoreThumbnails = function () {
            var $showMoreButton = $dom.find('[data-element="product-images--show-more-button"]')
            var $thumbnails = $dom.find('[data-product-images="thumbnails"]')

            if ($showMoreButton.length) {
                $showMoreButton.on('click', function () {
                    $(this).toggleClass('active')
                    $thumbnails.toggleClass('hide-extra-child-items')
                })
            }
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.thumbnailsInteraction()
            _this.showMoreThumbnails()
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.productDetailPageImageGallery = productDetailPageImageGallery
})()

$(document).ready(function () {
    var $productImagesElement = $('[data-product="images"]')

    if ($productImagesElement.length >= 1) {
        for (var i = 0; i < $productImagesElement.length; i++) {
            new window.Creaton.productDetailPageImageGallery($($productImagesElement[i]))
        }
    }
})
